import { TFunction } from 'i18next';
import { MessageDetailDto } from '../../../../interfaces/dtos/MessageDetailDto';
import { MessageDetails } from '../../../../interfaces/MessageDetails';
import transformMessage from '../transformMessage/transformMessage';
import transformPagination from '../transformPagination/transformPagination';

export default function transformMessageDetail(dto: MessageDetailDto, t: TFunction<'DetailsLoader'>): MessageDetails {
  const result: MessageDetails = {
    pagination: transformPagination(dto.pagination),
    data: transformMessage(dto.data, t),
    isShouldMarkAsRead: dto.behaviours?.isShouldMarkAsRead,
    canReply: dto.behaviours?.permissionLevel?.canReply,
  };
  return result;
}
